import { getCurrentClientUserManager,userManager, viewerUserManager } from "../auth/userManager";
import { ROUTE_PATHS } from "../routes/routePaths";
import authService from "../services/authService";

const KEYCLOAK_PENDING_ERROR_KEY = "keycloak_pending_error";

//show keycloak login with error code
export const redirectToKeyCloakLoginWithError = async (
  errorCode: string
): Promise<void> => {
  const { userManager: activeUserManager, clientId } = getCurrentClientUserManager();
  // Read id_token before clearing anything; Keycloak needs it to skip logout-confirm.
  const user = await activeUserManager.getUser();
  const idToken = (user?.id_token ?? localStorage.getItem("id_token"))?.trim() || null;

  await activeUserManager.clearStaleState();
  await activeUserManager.removeUser();
  await userManager.removeUser();
  await viewerUserManager.removeUser();

  // Never call Keycloak logout without id_token_hint → else logout-confirm page and infinite loop.
  if (!idToken || idToken.length === 0) {
    sessionStorage.setItem(KEYCLOAK_PENDING_ERROR_KEY, errorCode);
    window.location.href = `${window.location.origin}${ROUTE_PATHS.LOGIN}`;
    return;
  }
  authService.customLogout();

  // Set AFTER customLogout (which does sessionStorage.clear) so our key survives until SPA reads it.
  sessionStorage.setItem(KEYCLOAK_PENDING_ERROR_KEY, errorCode);

  // Base URI only - no query params. Keycloak ignores kc_error on logout.
  // Error is passed via sessionStorage; SPA Login reads it and adds kc_error to signinRedirect.
  const postLogoutRedirectUri = `${window.location.origin}${ROUTE_PATHS.LOGIN}`;

  await activeUserManager.signoutRedirect({
    id_token_hint: idToken,
    post_logout_redirect_uri: postLogoutRedirectUri,
    ...(clientId && {
      extraQueryParams: { client_id: clientId },
    }),
  });
};

export { KEYCLOAK_PENDING_ERROR_KEY };
